import styled from 'styled-components';

export const LastReviewsSkeletonContainer = styled.div`

`;